<script setup lang="ts">
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group"
import Callout from './Callout.vue'

const props = defineProps<{
  id: string
  target: HTMLElement | null
  show: boolean
  resourceFilter: any
  users: any[]
}>()

const emit = defineEmits(['close', 'updateFilter', 'openPersonModal'])
</script>

<template>
  <Callout :id="id" :target="target" :show="show" @close="emit('close')">
    <div class="flex flex-col space-y-2" @click.stop>
      <div class="w-fit rounded-md gap-4 bg-popover p-2">
        <RadioGroup :model-value="resourceFilter.selection" class="flex flex-col space-y-2">
          <div class="flex items-center space-x-2 cursor-pointer rounded-md px-2 py-1 hover:bg-muted" @click="emit('updateFilter', { ...resourceFilter, selection: 0 })">
            <RadioGroupItem :value="0" />
            <span>gebucht</span>
          </div>
          <div class="flex items-center space-x-2 cursor-pointer rounded-md px-2 py-1 hover:bg-muted" @click="emit('openPersonModal')">
            <RadioGroupItem :value="1" />
            <span>auswählen</span>
          </div>
          <div class="flex items-center space-x-2 cursor-pointer rounded-md px-2 py-1 hover:bg-muted" @click="emit('updateFilter', { ...resourceFilter, selection: 2 })">
            <RadioGroupItem :value="2" />
            <span>Alle</span>
          </div>
        </RadioGroup>
      </div>
    </div>
  </Callout>
</template>